import React, { memo, useMemo } from 'react';
import AppIcon from './AppIcon';
import AppImage from './AppImage';
const LOGO_SRC = '/assets/images/awakasha-logo-main.png';
const LOGO_ASPECT = 679 / 1958;

const AppLogo = memo(function AppLogo({ src = LOGO_SRC, iconName = 'SparklesIcon', size = 420, className = '', onClick, }) {
    // Memoize className calculation
    const containerClassName = useMemo(() => {
        const classes = ['flex items-center'];
        if (onClick)
            classes.push('cursor-pointer hover:opacity-80 transition-opacity');
        if (className)
            classes.push(className);
        return classes.join(' ');
    }, [onClick, className]);
    return (<div className={containerClassName} onClick={onClick}>
      {/* Show image if src provided, otherwise show icon */}
      {src ? (<AppImage src={src} alt="Awakasha Entertainment" width={size} height={Math.round(size * LOGO_ASPECT)} className="flex-shrink-0 h-auto bg-transparent object-contain object-left" priority={true} unoptimized={true}/>) : (<AppIcon name={iconName} size={size} className="flex-shrink-0"/>)}
    </div>);
});
export default AppLogo;
